import MenuResponsive from './Components/Menu';
import Offcanvas from './Components/Offcanvas';

window.addEventListener('DOMContentLoaded', () => {
   new MenuResponsive();
   new Offcanvas();
});
